/* eslint-disable react/prop-types */
/* eslint-disable react-native/no-inline-styles */
/*
Author: Granite Bagas
*/

import React, { useRef } from 'react';
import { useDispatch } from 'react-redux';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { View, Dimensions, ScrollView } from 'react-native';
import Alert from '@components/global/Alert';
import ModalFull from '@components/modal/ModalFull';
import SociollaText from '@components/sociolla/SociollaText';
import Button from '@components/form/Button';
import Input from '@components/form/Input';
import SelectProductV2 from '@components/form/SelectProductV2';
import {
  Wrapper,
  FormWrapper,
  FormGroup,
  ButtonSticky,
} from '@components/screen/Layout';
import Colors from '@global/colors';
import { isWeb, isAndroid, isNative, isMobileWeb } from '@global/screens';
import { showPopup } from '@/store/modal';
import { showAlert } from '@/store/global';

import { logEvent } from '@global/analytics';

const dimension = Dimensions.get('screen');
const heightContainer = isWeb
  ? dimension.height - 200
  : isMobileWeb
  ? dimension.height - 55
  : 0;

const AddProduct = ({
  detail,
  show,
  isDetail = false,
  products = [],
  orderId = '',
  onClose = () => {},
  setProducts = () => {},
}) => {
  const formProductRef = useRef();
  const dispatch = useDispatch();
  const showAddProduct = show ? true : false; // show or hide add product popup
  const productDetail = detail && Object.keys(detail).length ? detail : {}; // have product detail or not

  // add product validation
  const FormProductValidationSchema = Yup.object().shape({
    product: Yup.object().required('Product name / brand is required.'),
    quantity: Yup.string().required('Quantity is required.'),
  });

  return (
    <ModalFull
      title={
        isDetail
          ? `Product: ${productDetail?.name}`
          : `${productDetail?.name ? `Edit` : `Add`} Product`
      }
      show={showAddProduct}
      onClose={() => {
        onClose();
      }}>
      <Formik
        innerRef={formProductRef}
        initialValues={{
          product:
            productDetail && Object.keys(productDetail).length
              ? productDetail
              : '',
          quantity:
            productDetail?.quantity || productDetail?.quantity == 0
              ? productDetail.quantity
              : '',
        }}
        validationSchema={FormProductValidationSchema}
        onSubmit={(values) => {
          dispatch(showPopup({ name: 'isLoading', value: true }));
          const prd =
            values.product && values.product.id
              ? JSON.parse(JSON.stringify(values.product))
              : {};
          const comb =
            prd.combination && Object.keys(prd.combination).length
              ? prd.combination
              : {};
          const img =
            comb.images && comb.images.length ? comb.images[0].url : '';
          const qty = Number(values.quantity || 0);
          if (qty <= 0) {
            dispatch(
              showAlert({
                show: true,
                isModal: true,
                title: 'Error',
                description: 'Quantity product harus lebih dari 0.',
                isConfirm: false,
              }),
            );
            dispatch(showPopup({ name: 'isLoading', value: false }));
            return;
          }
          const payload = {
            id: prd.id,
            image: img,
            name: prd.name,
            category: prd.category,
            brand: prd.brand,
            combination: prd.combination,
            combination_id: prd.combination?._id,
            description: prd.description,
            how_to_use: prd.how_to_use,
            ingredients: prd.ingredients,
            quantity: qty,
            unit_price: values.unit_price,
            total_price_before_tax: values.total_price_before_tax,
            taxes: values.taxes,
            total_price: values.total_price,
          };
          const pr = JSON.parse(JSON.stringify(products));
          if (
            !productDetail?.name &&
            pr.findIndex(
              (a) =>
                a.id == payload.id &&
                a.combination_id == payload.combination_id,
            ) > -1
          ) {
            dispatch(
              showAlert({
                show: true,
                isModal: true,
                title: 'Error',
                description:
                  'This product has been added, please edit the product instead',
                isConfirm: false,
              }),
            );
            dispatch(showPopup({ name: 'isLoading', value: false }));
            return;
          }
          let index = -1;
          if (productDetail && Object.keys(productDetail).length) {
            const idx = pr.findIndex(
              (a) =>
                a.id == productDetail.id &&
                a.combination?.id?.toString() ==
                  productDetail.combination?.id?.toString(),
            );
            if (idx > -1) {
              index = idx;
              pr[idx] = payload;
            }
          } else {
            logEvent({
              eventName: 'add_product_sales_order',
              data: {
                ...payload,
                order_id: orderId,
              },
              dataKey: 'detail',
            });
            pr.push(payload);
          }
          setProducts({ val: pr, index: index }); // set new products value
          dispatch(showPopup({ name: 'isLoading', value: false }));
          onClose(); // close add product popup
        }}>
        {({ setFieldValue, handleSubmit, errors, touched, values }) => (
          <>
            <Wrapper fullWidth style={{ paddingBottom: isWeb ? 0 : 55 }}>
              <ScrollView
                style={
                  isWeb
                    ? { maxHeight: heightContainer }
                    : isMobileWeb
                    ? { height: heightContainer }
                    : {}
                }>
                <View
                  style={{
                    width: '100%',
                    paddingHorizontal: 10,
                    paddingVertical: 15,
                    marginBottom: isNative
                      ? isAndroid
                        ? 140
                        : 70
                      : isMobileWeb
                      ? 55
                      : 0,
                  }}>
                  <FormWrapper>
                    <View
                      style={{
                        width: '100%',
                        flexDirection: isWeb ? 'row' : 'column',
                        ...(isWeb ? { justifyContent: 'space-between' } : {}),
                      }}>
                      <View style={{ width: '100%' }}>
                        <FormGroup>
                          <SelectProductV2
                            label="Product Name / Brand"
                            placeholder="Select Product Name / Brand"
                            value={values.product}
                            hasError={
                              errors.product && touched.product
                                ? errors.product
                                : null
                            }
                            isRequired
                            bypassDefaultCombination
                            editable={!isDetail && !productDetail?.name}
                            onChange={(value) => {
                              setFieldValue('product', value);
                            }}
                          />
                        </FormGroup>
                        <FormGroup style={{ width: isWeb ? '48%' : '100%' }}>
                          <Input
                            label="Quantity"
                            value={
                              values.quantity || values.quantity == 0
                                ? values.quantity.toString()
                                : ''
                            }
                            keyboardType="numeric"
                            isNumeric
                            isRequired
                            editable={!isDetail}
                            hasError={
                              errors.quantity && touched.quantity
                                ? errors.quantity
                                : null
                            }
                            onChangeText={(value) => {
                              setFieldValue('quantity', value);
                            }}
                            rightIcon={
                              <SociollaText
                                type="bold"
                                style={{
                                  fontSize: 14,
                                  letterSpacing: 0.5,
                                }}>
                                Units
                              </SociollaText>
                            }
                          />
                        </FormGroup>
                      </View>
                    </View>
                  </FormWrapper>
                </View>
              </ScrollView>
            </Wrapper>
            {!isDetail ? (
              <>
                {isWeb ? (
                  <View
                    style={{
                      width: '100%',
                      paddingTop: 20,
                      paddingBottom: 20,
                      alignItems: 'center',
                    }}>
                    <Button
                      rounded
                      buttonStyle={{ width: 150 }}
                      title={
                        <SociollaText
                          type="bold"
                          style={{
                            fontSize: 14,
                            letterSpacing: 0.5,
                            color: Colors.white,
                          }}>
                          Save
                        </SociollaText>
                      }
                      onPress={handleSubmit}
                    />
                  </View>
                ) : (
                  <ButtonSticky
                    show
                    customHost="modal-sticky-button"
                    buttons={[
                      {
                        title: 'Save',
                        onPress: (e) => handleSubmit(e),
                      },
                    ]}
                  />
                )}
              </>
            ) : (
              false
            )}
          </>
        )}
      </Formik>
      <Alert />
    </ModalFull>
  );
};

export default AddProduct;
